import {
  OfferingBoardStatus,
  OfferingBoardStatusPayload,
} from './../pages/PI/PIOfferingBoard/Model/OfferingBoardStatus';
import { services } from './../utils/constants/APIConstant';
import { AxiosRequestConfig } from 'axios';
import { PTVNClient, HttpClientHelper, HeaderTypes } from '@ptvn-react/authentication';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import APIConstant from '../utils/constants/APIConstant';
import { PTVNResponse } from './response/BaseResponse';
import { PIResponse } from './response/PIResponse';
import {
  PIBookmark,
  PICartRequest,
  PICompareRequest,
  PIDraftPR,
  PIListRequest,
} from './request/PIRequest';
import { ListBookmarkParam } from '../pages/PI/PIBookmark/Model/ListBookmarkParams';
import Cookies from 'js-cookie';
import { CookieName } from '../utils/constants/CommonConstants';
import environment from 'environment';
import { OfferingBoardAdd } from '../pages/PI/PIOfferingBoard/Model/OfferingBoardAdd';
import {
  ConversationAttachment,
  ConversationFormPost,
  ConversationType,
} from '../pages/PI/PIOfferingBoard/Model/OfferingBoardConversation';
import { CommonHelper } from '../utils/helpers/CommonHelper';
import { PISortDirectionEnum } from '../pages/PI/Model/Sorting';
import fileDownload from 'js-file-download';

export class PIClient {
  public static getCompanyProfile(): Observable<PTVNResponse<any>> {
    const url = APIConstant.pi.getCompanyProfile;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPISearchList(
    request: PIListRequest,
  ): Observable<PTVNResponse<PIResponse.PIListResponse.Body>> {
    const url = APIConstant.pi.piSearchList;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.post(url, request, options).pipe(map((m) => m.data));
  }

  public static getSearchPI(
    search: string,
    page: number,
    pageSize: number,
  ): Observable<PTVNResponse<PIResponse.SearchItemsResponse[]>> {
    const url = `${APIConstant.pi.piSearch}?search=${search}&page=${page}&pageSize=${pageSize}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getTrendingSearchPI(
    days: number,
    limit: number,
  ): Observable<PTVNResponse<string[]>> {
    const url = `${APIConstant.pi.getTrendingSearchList}?days=${days}&limit=${limit}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getItemsForTrendingSearchKey(
    searchKey: string,
    orgID: string,
  ): Observable<PTVNResponse<PIResponse.SearchItemsResponse[]>> {
    const url = `${APIConstant.pi.getItemsForTrendingSearchKey}?keyword=${searchKey}&orgID=${orgID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPIDetailBuyerList(
    productId: number,
    companyID: number,
    roleID: number,
  ): Observable<PTVNResponse<PIResponse.PIDetailResponse.BuyerBody>> {
    const url = `${APIConstant.pi.piDetailBuyerList}?productID=${productId}&companyID=${companyID}&roleID=${roleID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPISupplierDetailBuyerList(
    productId: number,
    companyID: number,
  ): Observable<PTVNResponse<PIResponse.PIDetailResponse.BuyerBody>> {
    const url = `${APIConstant.pi.piSupplierDetailBuyerList}?productID=${productId}&companyID=${companyID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPIDetailProductOverview(
    productId: number,
    buyerBranchID: number | undefined,
    groupBy?: string,
  ): Observable<PTVNResponse<PIResponse.PIDetailResponse.ProductOverview>> {
    const url = `${APIConstant.pi.piDetailProductOverview}?productID=${productId}${
      buyerBranchID ? '&buyerBranchID=' + buyerBranchID : ''
    }`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(groupBy ? url + `&groupBy=${groupBy}` : url, options).pipe(
      map((m) => m.data),
    );
  }

  public static getPIPriceMovingAverage(
    productId: number,
    buyerBranchID: number | undefined,
    periods: string,
    periodType: string,
    fromDate: string,
    toDate: string,
    companyID: number,
    roleID: number,
  ): Observable<PTVNResponse<PIResponse.PIDetailResponse.ProductOverview>> {
    const url = `${APIConstant.pi.piDetailPriceMovingAverage}?productID=${productId}${
      buyerBranchID ? '&buyerBranchID=' + buyerBranchID : ''
    }&periods=${periods}&periodType=${periodType}&toDate=${toDate}&fromDate=${fromDate}&companyID=${companyID}&roleID=${roleID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getForecastPrice(
    productId: number,
    buyerBranchID: number | undefined,
  ): Observable<PTVNResponse<PIResponse.PIDetailResponse.ProductOverview>> {
    const url = `${APIConstant.pi.piDetailPriceMovingAverage}?productID=${productId}${
      buyerBranchID ? '&buyerBranchID=' + buyerBranchID : ''
    }`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getCommodityDetail(
    productId: number,
    buyerBranchID: number | undefined,
    periods: string,
    periodType: string,
    fromDate: string,
    toDate: string,
    // companyID: number,
    // roleID: number
  ): Observable<PTVNResponse<PIResponse.PIDetailResponse.ProductOverview>> {
    const url = `${APIConstant.pi.piDetailPriceMovingAverageCommodity}?productID=${productId}${
      buyerBranchID ? '&buyerBranchID=' + buyerBranchID : ''
    }&periods=${periods}&periodType=${periodType}&toDate=${toDate}&fromDate=${fromDate}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, {
      ...options,
      headers: {
        'x-ptvn-bypasstoken': environment.commodityBypassToken,
      },
    }).pipe(map((m) => m.data));
  }

  public static getPIDetailSubstitutionProduct(
    productID: number,
    pageSize: number,
  ): Observable<PTVNResponse<PIResponse.PIDetailResponse.SubstitutionProduct[]>> {
    const url = `${APIConstant.pi.piDetailSubstitutionProduct}?productID=${productID}&pageSize=${pageSize}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPIDetailTrendingProduct(
    productID: number,
    pageSize: number,
  ): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piDetailTrendingProduct}?productID=${productID}&pageSize=${pageSize}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPIDetailSuggestedSupplier(
    productID: number,
    supplierID: number,
    pageSize: number,
    companyID: number,
    roleID: number,
  ): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piDetailSuggestedSupplier}?productID=${productID}&supplierID=${supplierID}&companyID=${companyID}&roleID=${roleID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPISupplierDetail(
    productID: number,
    supplierID: number,
  ): Observable<PTVNResponse<PIResponse.PISupplierDetailReponse.SupplierDetail>> {
    const url = `${APIConstant.pi.piSupplierDetail}?productID=${productID}&supplierID=${supplierID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPICategory(categoryID?: number): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piCategory}${categoryID ? `?category=${categoryID}` : ''}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPICategoryDetail(categoryID: number): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piCategory}?category=${categoryID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPICategoryProduct(categoryID: number): Observable<PTVNResponse<any>> {
    const url = `${services.eMarketplaceCategoryProduct}?categoryID=${categoryID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPISupplierDetailPoOverview(
    buyerBranchID: number,
    supplierID: number,
  ): Observable<PTVNResponse<PIResponse.PISupplierDetailPoDetailReponse.PoDetail>> {
    const url = `${APIConstant.pi.piPoDetail}?buyerBranchID=${buyerBranchID}&supplierID=${supplierID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPIBookmarkList(
    request: ListBookmarkParam,
  ): Observable<PTVNResponse<PIResponse.PIBookmark.Body>> {
    const url = `${APIConstant.pi.piBookmark}/list`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.post(url, request, options).pipe(map((m) => m.data));
  }

  public static bookmark(item: PIBookmark.AddBookmark): Observable<PTVNResponse<any>> {
    const url = APIConstant.pi.piBookmark;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.post(url, item, options).pipe(map((m) => m.data));
  }

  public static deleteBookmark(item: PIBookmark.DeleteBookmark): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piBookmark}/delete`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.post(url, item, options).pipe(map((m) => m.data));
  }

  public static getCountCart(): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piCart}/count`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getCountBookmark(): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piBookmark}/count`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static addToCart(request: PICartRequest.AddToCart): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piCart}/create`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.post(url, request, options).pipe(map((m) => m.data));
  }

  public static addToCompare(request: PICompareRequest.Body): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piCompare}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.post(url, request, options).pipe(map((m) => m.data));
  }

  public static getPICartData(
    day: number | 'all' = 'all',
  ): Observable<PTVNResponse<PIResponse.PICart.CartData>> {
    const url = `${APIConstant.pi.piCartList}?days=${day}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPICartDetail(
    day: number | string = 'all',
    productId?: number,
    branchID?: number,
    supplierID?: number,
  ): Observable<PTVNResponse<PIResponse.PICart.CartDetail>> {
    const url = `${APIConstant.pi.piCart}?days=${day}&productID=${productId}&branchID=${branchID}&supplierID=${supplierID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static deletePICartData(request: PICartRequest.DeleteItem): Observable<PTVNResponse<{}>> {
    const url = `${APIConstant.pi.piCart}/delete`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.post(url, request, options).pipe(map((m) => m.data));
  }

  public static deletePICartList(
    request: PICartRequest.DeleteItem[],
  ): Observable<PTVNResponse<{}>> {
    const url = `${APIConstant.pi.piCart}/delete-all`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.post(url, { deleteList: request }, options).pipe(map((m) => m.data));
  }

  public static createPIDraftPR(request: PICartRequest.CartItem[]): Observable<PTVNResponse<{}>> {
    const url = `${APIConstant.pi.piDraftPR}/create`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    const sid = decodeURIComponent(Cookies.get(CookieName.UAA_AUTH_ID) as string);
    return PTVNClient.post(url, { cartItemInfos: request, sid: sid }, options).pipe(
      map((m) => m.data),
    );
  }

  public static getListDraftPR(
    request: PIDraftPR.PIListDraftPR.Body,
  ): Observable<PTVNResponse<PIResponse.PIDraftPR.PIDraftPRList>> {
    const url = `${APIConstant.pi.piDraftPR}/list`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.post(url, request, options).pipe(map((m) => m.data));
  }

  public static getPIPermissionAuth(): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piPermission}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPISupplierPopularProducts(
    day: number,
    productId: number,
  ): Observable<PTVNResponse<PIResponse.PIDetailResponse.PopularProduct>> {
    const url = `${APIConstant.pi.piPopularProducts}?day=${day}&productID=${productId}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPISupplierDetailOverview(
    productId: number,
    buyerBranchID: number | undefined,
    orgID: string,
    groupBy?: string,
  ): Observable<PTVNResponse<PIResponse.PISupplierDetailPoDetailReponse.PoDetail>> {
    const url = `${APIConstant.pi.piSupplierDetailtOverview}?orgID=${orgID}&productID=${productId}${
      buyerBranchID ? '&buyerBranchID=' + buyerBranchID : ''
    }`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(groupBy ? url + `&groupBy=${groupBy}` : url, options).pipe(
      map((m) => m.data),
    );
  }

  public static getPIDetailCompetitors(
    productID: number,
    companyID: number,
    orgID: string,
  ): Observable<PTVNResponse<PIResponse.PIDetailResponse.SubstitutionProduct[]>> {
    const url = `${APIConstant.pi.piDetailCompetitors}?productID=${productID}&companyID=${companyID}&orgID=${orgID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPITableVisitor(
    page: number,
    size: number,
    orgID: string,
  ): Observable<PTVNResponse<PIResponse.PIDetailResponse.SubstitutionProduct[]>> {
    const url = `${APIConstant.pi.piVisitorCount}/list?page=${page}&size=${size}&orgID=${orgID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPITableBookmark(
    page: number,
    size: number,
    orgID: string,
  ): Observable<PTVNResponse<PIResponse.PIDetailResponse.SubstitutionProduct[]>> {
    const url = `${APIConstant.pi.piBookmarkCount}/list?page=${page}&size=${size}&orgID=${orgID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPITableCart(
    page: number,
    size: number,
    orgID: string,
  ): Observable<PTVNResponse<PIResponse.PIDetailResponse.SubstitutionProduct[]>> {
    const url = `${APIConstant.pi.piAddToCartCount}/list?page=${page}&size=${size}&orgID=${orgID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static viewerTracking(request: {
    productID: number;
    tenantID: string;
  }): Observable<PTVNResponse<{}>> {
    const url = `${APIConstant.pi.piViewerCount}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.post(url, request, options).pipe(map((m) => m.data));
  }

  public static visitorTracking(request: {
    supplierID: number;
    productID: number;
    tenantID: string;
  }): Observable<PTVNResponse<{}>> {
    const url = `${APIConstant.pi.piVisitorCount}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.post(url, request, options).pipe(map((m) => m.data));
  }

  public static bookmarkTracking(request: {
    supplierID: number;
    productID: number;
    tenantID: string;
  }): Observable<PTVNResponse<{}>> {
    const url = `${APIConstant.pi.piBookmarkCount}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.post(url, request, options).pipe(map((m) => m.data));
  }

  public static cartTracking(request: {
    supplierID: number;
    productID: number;
    tenantID: string;
  }): Observable<PTVNResponse<{}>> {
    const url = `${APIConstant.pi.piAddToCartCount}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.post(url, request, options).pipe(map((m) => m.data));
  }

  public static getPIProfileVisitor(
    period: string,
    date: string | undefined,
    orgID: string,
  ): Observable<PTVNResponse<PIResponse.PIDetailResponse.ProductOverview>> {
    const url = `${APIConstant.pi.piVisitorCount}/statistics?orgID=${orgID}&period=${period}${
      date ? '&date=' + date : ''
    }`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPIProfileBookmark(
    period: string,
    date: string | undefined,
    orgID: string,
  ): Observable<PTVNResponse<PIResponse.PIDetailResponse.ProductOverview>> {
    const url = `${APIConstant.pi.piBookmarkCount}/statistics?orgID=${orgID}&period=${period}${
      date ? '&date=' + date : ''
    }`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPIProfileCart(
    period: string,
    date: string | undefined,
    orgID: string,
  ): Observable<PTVNResponse<PIResponse.PIDetailResponse.ProductOverview>> {
    const url = `${APIConstant.pi.piAddToCartCount}/statistics?orgID=${orgID}&period=${period}${
      date ? '&date=' + date : ''
    }`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static updateSeenVisitor(orgID: string): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piVisitorCount}/${orgID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.put(url, undefined, options).pipe(map((m) => m.data));
  }

  public static updateSeenBookmark(orgID: string): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piBookmarkCount}/${orgID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.put(url, undefined, options).pipe(map((m) => m.data));
  }

  public static updateSeenCart(orgID: string): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piAddToCartCount}/${orgID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.put(url, undefined, options).pipe(map((m) => m.data));
  }

  public static updatePerformance(
    period: string,
    date: string | undefined,
    orgID: string,
  ): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piProfileDraftPR}?orgID=${orgID}&period=${period}${
      date ? '&date=' + date : ''
    }`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static updateDraftChart(
    period: string,
    date: string | undefined,
    orgID: string,
  ): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piDataDraftPRChart}?orgID=${orgID}&period=${period}${
      date ? '&date=' + date : ''
    }`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static updatePerformanceScores(orgID: string): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piPerformanceScore}?orgID=${orgID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static updateTransactions(
    page: number,
    pageSize: number,
    sortDate: string,
    sortOption: string,
    supplierID: number,
    productID: number,
    groupBy?: string,
  ): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piSupplierDetail}/transaction?page=${page}&size=${pageSize}&sort=${sortDate}&dir=${sortOption}&supplierID=${supplierID}&productID=${productID}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(groupBy ? url + `&groupBy=${groupBy}` : url, options).pipe(
      map((m) => m.data),
    );
  }

  public static getPIDetailCatalogTransaction(
    page: number,
    pageSize: number,
    sortDate: string,
    sortOption: string,
    supplierID: number | undefined,
    productID: number,
    onlyMyPO: boolean,
  ) {
    const url = `${APIConstant.pi.piDetailCatalog}/transactions?page=${page}&size=${pageSize}&sort=${sortDate}&dir=${sortOption}&supplierID=${supplierID}&productID=${productID}&onlyMyPO=${onlyMyPO}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getPITopSale(orgID: string, days: number): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piTopSale}?orgID=${orgID}&days=${days}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static updateCartItemQuantity(request: {
    branchID: number;
    productID: number;
    supplierID: number;
    quantity: number;
  }): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.piCart}/update`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.patch(url, request, options).pipe(map((m) => m.data));
  }

  public static postOfferingBoard(
    companyId: number,
    buyerBranchID: number,
    offeringObj: OfferingBoardAdd,
  ): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.postOfferingBoard}?companyID=${companyId}&buyerBranchID=${buyerBranchID}`;
    const payload = { ...offeringObj };
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.post(url, payload, options).pipe(map((m) => m.data.data));
  }

  public static updateOfferingBoard(
    companyId: number,
    buyerBranchID: number,
    offeringObj: OfferingBoardAdd,
  ): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.postOfferingBoard}?companyID=${companyId}&buyerBranchID=${buyerBranchID}`;
    const payload = { ...offeringObj };
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.put(url, payload, options).pipe(map((m) => m.data));
  }

  public static readOfferingBoardConversation(
    offeringID: number,
    readType: string,
  ): Observable<PTVNResponse<any>> {
    const url = APIConstant.pi.readOfferingBoardConversation.replace(
      '{offeringID}',
      offeringID.toString(),
    );
    const payload = { readType };
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.post(url, payload, options).pipe(map((m) => m.data));
  }

  public static getMyReadOfferingBoardConversation(
    offeringID: number,
  ): Observable<PTVNResponse<PIResponse.PIOfferingBoard.PIOfferingBoardReadDetail>> {
    const url = APIConstant.pi.readOfferingBoardConversation.replace(
      '{offeringID}',
      offeringID.toString(),
    );

    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getBuyerNotifyList(): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.getBuyerNotifyList}`;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getOfferingBoard(
    companyID: string,
    branchID: string,
    offeringID: string,
  ): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.getOfferingBoard}`
      .replace('{companyID}', companyID)
      .replace('{branchID}', branchID)
      .replace('{offeringID}', offeringID);

    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static postAcceptOfferingBoard(
    accept: boolean,
    offeringID: string,
    companyID: string,
  ): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.postAcceptOffering}`
      .replace('{offeringID}', offeringID)
      .replace('{companyID}', companyID);
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.post(url, { accept }, options).pipe(map((m) => m.data));
  }

  public static getBuyerOfferingBoardDetail(
    companyID: string,
    offeringID: string,
  ): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.getBuyerOfferingBoard}`
      .replace('{companyID}', companyID)
      .replace('{offeringID}', offeringID);

    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static updateOfferingStatus(
    offeringID: string,
    offeringStatusObj: OfferingBoardStatusPayload,
  ): Observable<PTVNResponse<any>> {
    const url = `${APIConstant.pi.updateOfferingStatus}`.replace('{offeringID}', offeringID);
    const payload = offeringStatusObj;
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.put(url, payload, options).pipe(map((m) => m.data));
  }

  public static getBuyerResponseList(
    offeringID: string,
    page: number,
    pageSize: number,
    sortBy: string,
    sortDir: string,
  ): Observable<PTVNResponse<any>> {
    const url =
      `${APIConstant.pi.getBuyerResponseList}?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortDir=${sortDir}`.replace(
        '{offeringID}',
        offeringID,
      );
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static postSellerConversation(
    offeringID: string,
    companyID: string,
    branchID: string,
    data: ConversationFormPost,
  ): Observable<PTVNResponse<any>> {
    const url = APIConstant.pi.postSellerConversation
      .replace('{offeringID}', offeringID)
      .replace('{companyID}', companyID)
      .replace('{branchID}', branchID);

    const body = {
      message: data.message,
      privacy: data.privacy,
    };
    const payload = CommonHelper.objectToFormData(body);
    if (data.attachments && data.attachments.length > 0) {
      for (const attachment of data.attachments) {
        if (attachment instanceof File) {
          payload.append('attachments', attachment);
        }
      }
    }

    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.post(url, payload, options).pipe(map((m) => m.data));
  }

  public static editPostSellerConversation(
    offeringID: string,
    companyID: string,
    branchID: string,
    conversationID: string,
    data: ConversationFormPost,
  ): Observable<PTVNResponse<any>> {
    const url = APIConstant.pi.editPostSellerConversation
      .replace('{offeringID}', offeringID)
      .replace('{companyID}', companyID)
      .replace('{branchID}', branchID)
      .replace('{conversationID}', conversationID);

    const body = {
      privacy: data.privacy,
      message: data.message,
    };
    const payload = CommonHelper.objectToFormData(body);
    if (data.attachments && data.attachments.length > 0) {
      for (const attachment of data.attachments) {
        if (attachment instanceof File) {
          payload.append('attachments', attachment);
        }
      }
    }

    if (data.attachmentRemoveIDs && data.attachmentRemoveIDs.length > 0) {
      for (let index = 0; index < data.attachmentRemoveIDs.length; index++) {
        const attachmentId: any = data.attachmentRemoveIDs[index];
        payload.append('attachmentRemoveIDs', attachmentId);
      }
    }

    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.put(url, payload, options).pipe(map((m) => m.data));
  }

  public static cancelPostSellerConversation(
    offeringID: string,
    companyID: string,
    branchID: string,
    conversationID: string,
  ): Observable<PTVNResponse<any>> {
    const url = APIConstant.pi.cancelPostSellerConversation
      .replace('{offeringID}', offeringID)
      .replace('{companyID}', companyID)
      .replace('{branchID}', branchID)
      .replace('{conversationID}', conversationID);

    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.patch(url, {}, options).pipe(map((m) => m.data));
  }

  public static postBuyerConversation(
    offeringID: string,
    companyID: string,
    data: ConversationFormPost,
  ): Observable<PTVNResponse<any>> {
    const url = APIConstant.pi.postBuyerConversation
      .replace('{offeringID}', offeringID)
      .replace('{companyID}', companyID);

    const body = {
      message: data.message,
      privacy: data.privacy,
      notifySupplierResponded: data.notifySupplierResponded,
    };
    const payload = CommonHelper.objectToFormData(body);
    if (data.attachments && data.attachments.length > 0) {
      for (const attachment of data.attachments) {
        if (attachment instanceof File) {
          payload.append('attachments', attachment);
        }
      }
    }

    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.post(url, payload, options).pipe(map((m) => m.data));
  }

  public static editPostBuyerConversation(
    offeringID: string,
    companyID: string,
    conversationID: string,
    data: ConversationFormPost,
  ): Observable<PTVNResponse<any>> {
    const url = APIConstant.pi.editPostBuyerConversation
      .replace('{offeringID}', offeringID)
      .replace('{companyID}', companyID)
      .replace('{conversationID}', conversationID);

    const body = {
      message: data.message,
      privacy: data.privacy,
      notifySupplierResponded: data.notifySupplierResponded,
    };

    const payload = CommonHelper.objectToFormData(body);
    if (data.attachments && data.attachments.length > 0) {
      for (const attachment of data.attachments) {
        if (attachment instanceof File) {
          payload.append('attachments', attachment);
        }
      }
    }

    if (data.attachmentRemoveIDs && data.attachmentRemoveIDs.length > 0) {
      for (let index = 0; index < data.attachmentRemoveIDs.length; index++) {
        const attachmentId: any = data.attachmentRemoveIDs[index];
        payload.append('attachmentRemoveIDs', attachmentId);
      }
    }

    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.put(url, payload, options).pipe(map((m) => m.data));
  }

  public static cancelPostBuyerConversation(
    offeringID: string,
    companyID: string,
    conversationID: string,
  ): Observable<PTVNResponse<any>> {
    const url = APIConstant.pi.cancelPostBuyerConversation
      .replace('{offeringID}', offeringID)
      .replace('{companyID}', companyID)
      .replace('{conversationID}', conversationID);

    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.patch(url, {}, options).pipe(map((m) => m.data));
  }

  public static getSellerConversation(
    offeringID: string,
    companyID: string,
    branchID: string,
    filter: {
      sortBy: string;
      sortDir: PISortDirectionEnum;
      noReply: boolean;
      myPost: boolean;
    },
  ): Observable<PTVNResponse<any>> {
    const url =
      `${APIConstant.pi.getSellerConversation}?sortBy=${filter.sortBy}&sortDir=${filter.sortDir}&noReply=${filter.noReply}&myPost=${filter.myPost}`
        .replace('{offeringID}', offeringID)
        .replace('{companyID}', companyID)
        .replace('{branchID}', branchID);
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static getBuyerConversation(
    offeringID: string,
    companyID: string,
    filter: {
      sortBy: string;
      sortDir: PISortDirectionEnum;
      noReply: boolean;
      myPost: boolean;
    },
  ): Observable<PTVNResponse<any>> {
    const url =
      `${APIConstant.pi.getBuyerConversation}?sortBy=${filter.sortBy}&sortDir=${filter.sortDir}&noReply=${filter.noReply}&myPost=${filter.myPost}`
        .replace('{offeringID}', offeringID)
        .replace('{companyID}', companyID);
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);

    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

  public static downloadFileWithAuth(path: string, fileName: string): Observable<boolean> {
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.get(path, { ...options, responseType: 'blob' }).pipe(
      map((response) => {
        fileDownload(response.data, fileName);
        return true;
      }),
      catchError((err) => throwError(err)),
    );
  }

  public static downloadSellerConversationAttachment(
    offeringID: string,
    companyID: string,
    branchID: string,
    conversationType: ConversationType,
    attachment: ConversationAttachment,
  ): Observable<boolean> {
    const url = `${APIConstant.pi.sellerDownloadAttachment}`
      .replace('{offeringID}', offeringID)
      .replace('{companyID}', companyID)
      .replace('{branchID}', branchID)
      .replace('{conversationType}', conversationType)
      .replace('{attachmentID}', `${attachment.attachmentID}`);
    return this.downloadFileWithAuth(url, attachment.originalFileName || 'unknown');
  }

  public static downloadBuyerConversationAttachment(
    offeringID: string,
    companyID: string,
    conversationType: ConversationType,
    attachment: ConversationAttachment,
  ): Observable<boolean> {
    const url = `${APIConstant.pi.buyerDownloadAttachment}`
      .replace('{offeringID}', offeringID)
      .replace('{companyID}', companyID)
      .replace('{conversationType}', conversationType)
      .replace('{attachmentID}', `${attachment.attachmentID}`);
    return this.downloadFileWithAuth(url, attachment.originalFileName || 'unknown');
  }

  public static replySellerConversation(
    offeringID: string,
    companyID: string,
    branchID: string,
    conversationID: string,
    data: ConversationFormPost,
  ): Observable<PTVNResponse<any>> {
    const url = APIConstant.pi.replySellerConversation
      .replace('{offeringID}', offeringID)
      .replace('{companyID}', companyID)
      .replace('{branchID}', branchID)
      .replace('{conversationID}', conversationID);

    const body = {
      message: data.message,
      privacy: data.privacy,
      repliedReplyID: data.repliedReplyID || null,
    };

    const payload = CommonHelper.objectToFormData(body);
    if (data.attachments && data.attachments.length > 0) {
      for (const attachment of data.attachments) {
        if (attachment instanceof File) {
          payload.append('attachments', attachment);
        }
      }
    }

    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.post(url, payload, options).pipe(map((m) => m.data));
  }

  public static editReplySellerConversation(
    offeringID: string,
    companyID: string,
    branchID: string,
    conversationID: string,
    replyID: string,
    data: ConversationFormPost,
  ): Observable<PTVNResponse<any>> {
    const url = APIConstant.pi.editReplySellerConversation
      .replace('{offeringID}', offeringID)
      .replace('{companyID}', companyID)
      .replace('{branchID}', branchID)
      .replace('{conversationID}', conversationID)
      .replace('{replyID}', replyID);

    const body = {
      message: data.message,
      privacy: data.privacy,
      repliedReplyID: data.repliedReplyID || null,
      attachmentIds: [1, 23, 5],
    };

    const payload = CommonHelper.objectToFormData(body);
    if (data.attachments && data.attachments.length > 0) {
      for (const attachment of data.attachments) {
        if (attachment instanceof File) {
          payload.append('attachments', attachment);
        }
      }
    }

    if (data.attachmentRemoveIDs && data.attachmentRemoveIDs.length > 0) {
      for (let index = 0; index < data.attachmentRemoveIDs.length; index++) {
        const attachmentId: any = data.attachmentRemoveIDs[index];
        payload.append('attachmentRemoveIDs', attachmentId);
      }
    }

    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.put(url, payload, options).pipe(map((m) => m.data));
  }

  public static cancelReplySellerConversation(
    offeringID: string,
    companyID: string,
    branchID: string,
    conversationID: string,
    replyID: string,
  ): Observable<PTVNResponse<any>> {
    const url = APIConstant.pi.cancelReplySellerConversation
      .replace('{offeringID}', offeringID)
      .replace('{companyID}', companyID)
      .replace('{branchID}', branchID)
      .replace('{conversationID}', conversationID)
      .replace('{replyID}', replyID);

    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.patch(url, {}, options).pipe(map((m) => m.data));
  }

  public static replyBuyerConversation(
    offeringID: string,
    companyID: string,
    conversationID: string,
    data: ConversationFormPost,
  ): Observable<PTVNResponse<any>> {
    const url = APIConstant.pi.replyBuyerConversation
      .replace('{offeringID}', offeringID)
      .replace('{companyID}', companyID)
      .replace('{conversationID}', conversationID);

    const body = {
      message: data.message,
      privacy: data.privacy,
      repliedReplyID: data.repliedReplyID || null,
    };
    const payload = CommonHelper.objectToFormData(body);
    if (data.attachments && data.attachments.length > 0) {
      for (const attachment of data.attachments) {
        if (attachment instanceof File) {
          payload.append('attachments', attachment);
        }
      }
    }

    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.post(url, payload, options).pipe(map((m) => m.data));
  }

  public static editReplyBuyerConversation(
    offeringID: string,
    companyID: string,
    conversationID: string,
    replyID: string,
    data: ConversationFormPost,
  ): Observable<PTVNResponse<any>> {
    const url = APIConstant.pi.editReplyBuyerConversation
      .replace('{offeringID}', offeringID)
      .replace('{companyID}', companyID)
      .replace('{conversationID}', conversationID)
      .replace('{replyID}', replyID);

    const body = {
      message: data.message,
      privacy: data.privacy,
    };
    const payload = CommonHelper.objectToFormData(body);
    if (data.attachments && data.attachments.length > 0) {
      for (const attachment of data.attachments) {
        if (attachment instanceof File) {
          payload.append('attachments', attachment);
        }
      }
    }

    if (data.attachmentRemoveIDs && data.attachmentRemoveIDs.length > 0) {
      for (let index = 0; index < data.attachmentRemoveIDs.length; index++) {
        const attachmentId: any = data.attachmentRemoveIDs[index];
        payload.append('attachmentRemoveIDs', attachmentId);
      }
    }

    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.put(url, payload, options).pipe(map((m) => m.data));
  }

  public static cancelReplyBuyerConversation(
    offeringID: string,
    companyID: string,
    conversationID: string,
    replyID: string,
  ): Observable<PTVNResponse<any>> {
    const url = APIConstant.pi.cancelReplyBuyerConversation
      .replace('{offeringID}', offeringID)
      .replace('{companyID}', companyID)
      .replace('{conversationID}', conversationID)
      .replace('{replyID}', replyID);

    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.patch(url, {}, options).pipe(map((m) => m.data));
  }
}
